<div class="loading-screen" [ngClass]="{'d-none': !loading, 'd-flex': loading}">
  <img class="loading-img" src="assets/imgBeriStar/loadingSpinner.gif">
</div>
